import 'gsap';
import $ from '@vaersaagod/tools/Dom';
import * as eventKeys from '../lib/events';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Components from '@vaersaagod/tools/Components';
import Viewport from '@vaersaagod/tools/Viewport';
import { deferredCallback } from '@vaersaagod/tools/utils';

let $body;

let backTriggered = false;

const setBackTriggered = () => {
    backTriggered = true;
};

const init = () => {
    window.onpopstate = function(event) {
        //console.log("location: " + document.location + ", state: " + JSON.stringify(event.state));
        
        if (!backTriggered) {
            window.location.reload();
        }
        
        backTriggered = false;
    };
};

// Public api for module
export default {
    init,
    setBackTriggered
};



// WEBPACK FOOTER //
// ./src/js/modules/Navigator.js